export async function appelerRendezVous(client, action, donnees = {}) {
  const { data, error } = await client.functions.invoke("crm-rendez-vous", { body: { action, ...donnees } });
  if (error) throw error;
  if (data?.erreur) throw new Error(data.erreur);
  return data;
}

export function annulerDemandeRdv(client, demandeId, raison = "") {
  return appelerRendezVous(client, "annuler", { demande_id: demandeId, raison });
}
